import React from 'react'
import image from '../../../assets/homepage_icon3.png'
import image2 from '../../../assets/homepage_icon2.png'
const LowerBarCart = () => {
  return (
    <>
     <div className='cart-bar'>
            <ul className="cart-lst">
              {/* <li>
                <a href="compare-product.html">
                  <em>Compare</em> <img src="images/icon1.png" alt="" />{" "}
                  <span>0</span>
                </a>
              </li> */}
              <li>
                <a href="#">
                  <img src={image2} alt="" />
                  <span>0</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={image} alt="" />
                  <span>0</span>
                </a>
              </li>
            </ul>
          </div>
    </>
  )
}

export default LowerBarCart